import type { IconAsset } from "./assets";

const ICON_SIZE = 52;
export const FALL_SPEED = 2.4; // px per frame (~144px/s at 60fps — about 2.1s to cross 300px)

export class FallingIcon {
  readonly el: HTMLImageElement;
  readonly isSpecial: boolean;
  readonly centerX: number;

  y: number = -ICON_SIZE;
  caught = false;
  exited = false;

  // fixedX: when provided (mobile mode), icon spawns at this exact X instead of random.
  // This is the column X that the avatar will lerp toward — guarantees a catch.
  constructor(asset: IconAsset, containerWidth: number, fixedX?: number) {
    this.isSpecial = asset.isSpecial;

    if (fixedX !== undefined) {
      this.centerX = fixedX;
    } else {
      // Desktop: random X with edge padding so icons don't spawn flush against edges
      const pad = ICON_SIZE * 0.8;
      this.centerX = pad + Math.random() * (containerWidth - pad * 2);
    }

    this.el = document.createElement("img");
    this.el.src = asset.url;
    this.el.className = "io-icon";
    this.el.draggable = false;
    Object.assign(this.el.style, {
      position: "absolute",
      width: `${ICON_SIZE}px`,
      height: `${ICON_SIZE}px`,
      objectFit: "contain",
      pointerEvents: "none",
      userSelect: "none",
      left: `${this.centerX - ICON_SIZE / 2}px`,
      top: `${this.y}px`,
      willChange: "top",
      zIndex: "9",
    });
  }

  get bottom(): number {
    return this.y + ICON_SIZE;
  }

  update(): void {
    this.y += FALL_SPEED;
    this.el.style.top = `${this.y}px`;
  }

  catch(): void {
    this.caught = true;
    this.el.classList.add("io-icon--caught");
    this.el.addEventListener("animationend", () => this.el.remove(), { once: true });
  }

  exit(): void {
    this.exited = true;
    this.el.remove();
  }
}
